import styled, {css} from 'styled-components';
import colors from '../../../../theme/constants/colors';
import pxToRem from '../../../../theme/helpers/pxToRem';
import {StyledProps} from './typings';
import Link from 'next/link';

const size = '40px';

const StyledPaginationNumber = styled(Link)<StyledProps & {href?: string | URL}>`
  ${(props) => css`
    cursor: ${props.$active ? 'default' : 'pointer'};
    user-select: none;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    display: none;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: ${props.$active ? colors.red100 : '#fff'};
    color: ${props.$active ? '#fff' : colors.darkBlue100};
    font-size: ${pxToRem(15)};
    border: 1px solid ${props.$active ? colors.red100 : colors.grey100};
    width: ${size};
    height: ${size};
    padding-top: 2px;
    ${props.$active && 'pointer-events: none;'}

    ${props.$disabled &&
    `
        cursor: default;
        background: #fff;
        color: ${colors.grey100};
        border-color: ${colors.grey100};
        pointer-events: none;
        font-weight: bold;
        `}
  `}

  // Styling to counter default styling from bootstap.css
  // TODO remove once sass files are removed
  &:hover {
    color: inherit;
  }
  ${(props) =>
    props.$active &&
    `
  &:hover {
    color: ${colors.white};
  }
  `}

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: ${colors.red100};
      border-color: ${colors.red100};
    }
  }

  @media only screen and (min-width: 400px) {
    display: flex;
  }
`;
export default StyledPaginationNumber;
